import { type CSSProperties } from 'react'

import { Flex } from '@/styled-system/jsx'

import SearchInput from '@/components/search/search-input'
import SearchResults from '@/components/search/search-results'

type HeaderSearchContentProps = {
  style: CSSProperties
}

export default function HeaderSearchContent({
  style,
}: HeaderSearchContentProps) {
  return (
    <Flex
      bgColor='#170D19'
      borderColor='#251929'
      borderStyle='solid'
      borderRadius='2xl'
      borderWidth={{ base: '0', md: '1px' }}
      borderBottomRadius={{ base: '0', md: '2xl' }}
      borderTop='0'
      borderTopRadius='0'
      direction='column'
      position='relative'
      overflow='hidden'
      p='5'
      mx='auto'
      maxH='750px'
      maxW={{ base: 'none', md: '1200px' }}
      h={{ base: 'full', md: 'fit' }}
      w='full'
      zIndex='10'
      style={style}
    >
      <SearchInput mb={4} />
      <SearchResults />
    </Flex>
  )
}
